import _ = require("lodash");
import { ClientRequestUIExcelInterface } from "./ClientRequestUIExcelInterface";
import { EntityConfiguration } from "../../configurations/configuration";
import { TemplateUIExcelInterface } from "../template/TemplateUIExcelInterface";
import { isNullOrUndefined, isNullOrWhitespace, currentResource, labels } from "../../util/utils";
import { ServiceDataModel } from "../models/Models";
import {
  CellIndexMapping,
  CommonConfiguration,
  ExcelColorValue,
  UploadStatus,
  statusIdsForClientRequestStatus,
} from "../../util/UIConstants";
import Utility from "../../util/utilityFunctions";
export class EditClientRequestUIExcelInterface extends ClientRequestUIExcelInterface {

  async validateInputData(
    updatedRows: Array<Excel.TableRow>,
    configuration: EntityConfiguration,
    enableValidation: boolean,
  ): Promise<any> {
    let response = await super.validateInputData(updatedRows, configuration, enableValidation);
    let modifiedRequests = response.modifiedRequests;
    const data = response.refrenceData;

    if (enableValidation) {
      _.forEach(modifiedRequests, (request, index) => {
        if (!request?.uploadError) {
          let cellIds = [
            "clientRequestStatusTypeId",
            "DueDate",
            "timephases",
            "assignedToGroups",
            "assignedToUsers",
            "priority",
          ];
          let DataValue: any = {};

          _.forEach(cellIds, (cellId) => {
            let cell = configuration.columns.find((x) => x.CellId === cellId);
            let cellValue = updatedRows[index].values.at(0)[cell.CellDisplayIndex].toString().trim();
            DataValue[cellId] = cellValue;
          });

          if (
            !DataValue.DueDate &&
            !DataValue.timephases &&
            (statusIdsForClientRequestStatus.pendingResponse.includes(parseInt(DataValue.clientRequestStatusTypeId)) ||
              statusIdsForClientRequestStatus.received.includes(parseInt(DataValue.clientRequestStatusTypeId)) ||
              statusIdsForClientRequestStatus.accepted.includes(parseInt(DataValue.clientRequestStatusTypeId)))
          ) {
            response.validationFail = true;
            request.uploadError = labels.dueDateRequired;
            request.uploadStatus = UploadStatus.InvalidInput;
            return;
          }

          if (
            !DataValue.assignedToGroups &&
            !DataValue.assignedToUsers &&
            (statusIdsForClientRequestStatus.pendingResponse.includes(parseInt(DataValue.clientRequestStatusTypeId)) ||
              statusIdsForClientRequestStatus.received.includes(parseInt(DataValue.clientRequestStatusTypeId)))
          ) {
            response.validationFail = true;
            request.uploadError = labels.requestNotAssignedError;
            request.uploadStatus = UploadStatus.InvalidInput;
            return;
          } 

          if (
            !DataValue.priority &&
            (statusIdsForClientRequestStatus.draft.includes(parseInt(DataValue.clientRequestStatusTypeId)) ||
              statusIdsForClientRequestStatus.pendingResponse.includes(parseInt(DataValue.clientRequestStatusTypeId)))
          ) {
            request.PriorityTypeId = 1;
            request.PriorityTypeIdvalue = data?.priorityreferenceData?.find(
              (record) => record.id == request.PriorityTypeId
            )?.value;
          }
        }
      });
    }

    response.modifiedRequests = modifiedRequests;
    return response;
  }

  getStartIndexOfSpecificStatus = (data, statusIDs, attributeName) => {
    if (data) {
      let startingIndex = data.findIndex((item) => statusIDs.includes(item[attributeName]));
      if (startingIndex === -1) return -1;
      return startingIndex + CommonConfiguration.dataStartingRowIndex;
    }
  };

  async applyFormattingOnLoad(
    activeSheet: Excel.Worksheet,
    beginDataRowIndex: number,
    endDataRowIndex: number,
    configuration,
    requestsModel: ServiceDataModel //
  ): Promise<any> {
    let columns = configuration.columns.filter((x) => x.CellFormat?.lockedCondition);
    columns.forEach((column) => {
      let cellName = CellIndexMapping[column.CellDisplayIndex];
      let attributeName = column.CellFormat.lockedCondition.dataAttributeName;
      let statusIDs = column.CellFormat.lockedCondition.clientRequestStatusID;
      let startIndexOfNonEditablefields = this.getStartIndexOfSpecificStatus(
        requestsModel.response?.requestsReadModel,
        statusIDs,
        attributeName
      );
      if (startIndexOfNonEditablefields > 0 && startIndexOfNonEditablefields <= endDataRowIndex+1) {
        let clientRequestFieldToProtect = activeSheet.getRange(
          `${cellName}${startIndexOfNonEditablefields}:${cellName}${endDataRowIndex + 1}`
        );
        clientRequestFieldToProtect.format.protection.locked = true;
        clientRequestFieldToProtect.format.fill.color = ExcelColorValue.GrayColor;
      }
    });
  }

  async updateWorksheetAfterUpload(
    context: Excel.RequestContext,
    sheet: Excel.Worksheet,
    existingRequestsTable: Excel.Table,
    uploadedRequests: Array<any>,
    configuration: EntityConfiguration,
    referenceSheetData: Object
  ): Promise<void> {
    return super.updateWorksheetAfterUpload(
      context,
      sheet,
      existingRequestsTable,
      uploadedRequests,
      configuration,
      referenceSheetData,
    );
  }

  async doChangesWhenChangingUpdateEYCanvas(
    context: Excel.RequestContext,
    sheet: Excel.Worksheet,
    firstUpdatedRowIndex: number,
    lastUpdatedRowIndex: number,
    configuration: EntityConfiguration,
    endingDataColumnCellName: string,
    markForUpdateCellName: string,
    uploadStatusCellName: string,
    uploadStatusIdCellName: string
  ): Promise<any> {
    super.doChangesWhenChangingUpdateEYCanvas(
      context,
      sheet,
      firstUpdatedRowIndex,
      lastUpdatedRowIndex,
      configuration,
      endingDataColumnCellName,
      markForUpdateCellName,
      uploadStatusCellName,
      uploadStatusIdCellName,
      true
    );
  }
}
